import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import * as LS from "local-storage";

const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_API_URL || "https://stage.greeneye.co.il/api/graphql",
});

const authLink = setContext((_, { headers }) => {
  const jwt = LS.getJwt();
  return {
    headers: {
      ...headers,
      authorization: jwt || "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
